export default "__VITE_ASSET__e1bb5d1e__"